class ProductLoyaltyPoints extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    document.addEventListener('swell:setup', () => {
      const swellCheck = setInterval(() => {
        if (window.swellAPI) {
          clearInterval(swellCheck)
          this.customerDetails = window.swellAPI.getCustomerDetails()
          this.currentPoints = this.customerDetails.pointsBalance
          this.activeRedemptions = window.swellAPI.getActiveRedemptionOptions()

          let highestReward = 0
          let rewardTitle = ''
          let pointsToNextReward = 1000
          let nextRewardTitle = ''

          let nextAvailableReward = ''

          this.activeRedemptions.forEach(element => {
            const cost = element.costInPoints
            if (
              element.name.includes('Charity') ||
              element.name.includes('Donation')
            ) {
              return
            }

            const pointsToCurrentReward =
              cost -
              (this.currentPoints + Number.parseInt(this.dataset.productPoints))

            if (
              pointsToCurrentReward > 0 &&
              pointsToCurrentReward < pointsToNextReward
            ) {
              pointsToNextReward = pointsToCurrentReward
              nextRewardTitle = element.name
            }

            if (this.currentPoints > cost && cost > highestReward) {
              highestReward = cost
              rewardTitle = element.name
            }

            if (
              this.currentPoints < cost &&
              this.currentPoints + Number.parseInt(this.dataset.productPoints) >
                cost
            ) {
              nextAvailableReward = element.name
            }
          })

          if (this.customerDetails.isOptIn === true) {
            const textElement = this.els.text.element
            const productPoints = this.dataset.productPoints

            if (highestReward > 0) {
              let rewardAvailableMessage =
                textElement.dataset.rewardAvailableMessage
              rewardAvailableMessage = rewardAvailableMessage.replace(
                '[points]',
                productPoints,
              )
              rewardAvailableMessage = rewardAvailableMessage.replace(
                '[reward]',
                rewardTitle,
              )

              textElement.innerHTML = rewardAvailableMessage
            } else {
              if (nextAvailableReward) {
                let rewardCollectMessage =
                  textElement.dataset.rewardCollectMessage
                rewardCollectMessage = rewardCollectMessage.replace(
                  '[points]',
                  productPoints,
                )
                rewardCollectMessage = rewardCollectMessage.replace(
                  '[reward]',
                  nextAvailableReward,
                )
                textElement.innerHTML = rewardCollectMessage
              } else {
                let rewardUnavailableMessage =
                  textElement.dataset.rewardUnavailableMessage
                rewardUnavailableMessage = rewardUnavailableMessage.replace(
                  '[points]',
                  productPoints,
                )
                rewardUnavailableMessage = rewardUnavailableMessage.replace(
                  '[reward]',
                  nextRewardTitle,
                )
                rewardUnavailableMessage = rewardUnavailableMessage.replace(
                  '[customer_points_to_next_reward]',
                  pointsToNextReward,
                )

                textElement.innerHTML = rewardUnavailableMessage
              }
            }
          }
        }
      }, 500)
    })
  }
}

if (!customElements.get('product-loyalty-points')) {
  customElements.define('product-loyalty-points', ProductLoyaltyPoints)
}
